import {
  Users,
  FileText,
  UserPen,
  CreditCard,
  BadgePercent,
  Store,
  ReceiptText,
  ListChecks,
  ArrowLeftRight,
  ArrowUpFromLine,
  Settings2,
  Award
} from "lucide-react";
import { Role } from "./utils/schema/schema";
import { i18n } from "i18next";

const baseNavigationItems = [
  { icon: FileText, key: "navigation.dashboard", to: "/" },
  // { icon: Users, key: "navigation.customers", to: "/customer" },
  { icon: FileText, key: "navigation.contracts", to: "/contract" },
  // {
  //   icon: ReceiptText,
  //   key: "navigation.partnerBilling",
  //   to: "/partner-billing",
  //   role: Role.Partner,
  // },
  {
    icon: UserPen,
    key: "navigation.partners",
    to: `/partner`,
    role: Role.SGB,
  },
  {
    icon: Store,
    key: "navigation.distributionChannels",
    to: "/distributionChannel",
    role: Role.SGB,
  },
  {
    icon: BadgePercent,
    key: "navigation.provision",
    to: "/provision",
    role: Role.SGB,
  },
  {
    icon: ArrowUpFromLine,
    key: "navigation.pushProvision",
    to: "/pushProvision",
    role: Role.SGB,
  },
  {
    icon: FileText,
    key: "navigation.consumption",
    to: "/consumption",
    role: Role.SGB,
  },
  {
    icon: ReceiptText,
    key: "navigation.billing",
    to: "/billing",
    role: Role.SGB,
  },
  // {
  //   icon: ListChecks,
  //   key: "navigation.visualInspection",
  //   to: "/visualInspection",
  //   role: Role.SGB,
  // },
  {
    icon: CreditCard,
    key: "navigation.commissionCredits",
    to: "/commissionCredits",
    role: Role.SGB,
  },
  {
    icon: FileText,
    key: "navigation.exportXML",
    to: "/export-xml",
    role: Role.SGB,
  },
  {
    icon: ArrowLeftRight,
    key: "navigation.collectiveTransfer",
    to: "/collectiveTransfer",
    role: Role.SGB,
  },
  {
    icon: Settings2,
    key: "navigation.portalSettings",
    to: "/portalSettings",
    role: Role.SGB,
  },
  // {
  //   icon: Award,
  //   key: "navigation.commissionRates",
  //   to: "/commission-rates",
  //   role: Role.SGB,
  // },
];

export const NavigationItems = (i18n: i18n, partnerId: string) => 
  baseNavigationItems.map(item => ({
    ...item,
    label: i18n.t(item.key),
    to: item.to
  }));
